/* eslint-disable react/prop-types */
import React from 'react';
import { string } from 'prop-types';

export function NikeIcon({ modifier }) {
  return (
    <svg
      className={modifier ? `icon icon__fill ${modifier}` : 'icon icon__fill'}
      width={200}
      height={72}
      viewBox="135.5 361.375 200 72"
      overflow="visible"
    >
      <path d="M159.23 431.966c-5.84-.232-10.618-1.83-14.354-4.798-.713-.567-2.412-2.267-2.982-2.984-1.515-1.905-2.545-3.759-3.232-5.816-2.114-6.332-1.026-14.641 3.112-23.76 3.543-7.807 9.01-15.55 18.548-26.274 1.405-1.578 5.589-6.193 5.616-6.193.01 0-.218.395-.505.876-2.48 4.154-4.602 9.047-5.758 13.283-1.857 6.797-1.633 12.63.656 17.153 1.579 3.116 4.286 5.815 7.33 7.307 5.329 2.611 13.131 2.827 22.659.632.656-.152 33.162-8.781 72.236-19.176a88696.433 88696.433 0 0171.054-18.888c.011.009-90.78 38.859-137.911 59.014-7.464 3.191-9.46 3.997-12.969 5.229-8.97 3.15-17.005 4.653-23.5 4.395z" />
    </svg>
  );
}

NikeIcon.propTypes = {
  modifier: string,
};
